import React, { useCallback, useState } from 'react'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import HeaderContactOptionsModal from './HeaderContactOptionsModal'
import IconButton from 'components/Luxkit/Button/IconButton'

interface Props {
  className?: string;
}

function HeaderContactOptionsMenu(props: Props) {
  const [isOpen, setOpen] = useState(false)

  const toggleOpen = useCallback(() => {
    setOpen(!isOpen)
  }, [isOpen, setOpen])

  return <div {...props}>
    <IconButton
      kind="tertiary"
      onClick={toggleOpen}
      aria-expanded={isOpen}
      variant="dark"
      aria-label="Need Help? Call our Travel Experts"
      rel="nofollow"
      size="large"
    >
      <LinePhoneIcon />
    </IconButton>
    <HeaderContactOptionsModal isOpen={isOpen} onClose={toggleOpen} />
  </div>
}

export default HeaderContactOptionsMenu
